import { render, staticRenderFns } from "./visit_records.vue?vue&type=template&id=fde1a8ce&scoped=true"
import script from "./visit_records.vue?vue&type=script&lang=js"
export * from "./visit_records.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/visit_records.css?vue&type=style&index=0&id=fde1a8ce&prod&scoped=true&lang=css&external"
import style1 from "./visit_records.vue?vue&type=style&index=1&id=fde1a8ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde1a8ce",
  null
  
)

export default component.exports